module.exports = __webpack_public_path__ + "static/media/qr_code_example.94dfb9eb.png";